import React, { createContext, ReactElement, ReactNode, useContext } from 'react';

export interface ProductViewer {
  /** A client of the product: the same page, read-only, without the tools that only set a product up. */
  isClient: boolean;
}

const ProductViewerContext = createContext<ProductViewer>({ isClient: false });

export const ProductViewerProvider = ({
  viewer,
  children,
}: {
  viewer: ProductViewer;
  children: ReactNode;
}): ReactElement => <ProductViewerContext.Provider value={viewer}>{children}</ProductViewerContext.Provider>;

export const useProductViewer = (): ProductViewer => useContext(ProductViewerContext);
